// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"359":"b44ac9b5","767":"9e224eea"}[chunkId] + ".chunk.js");